export { default } from './MultipleSelect';
